var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "pp4n459hqa",
    d: "M18.667 0C19.403 0 20 .597 20 1.333V16c0 .737-.597 1.333-1.333 1.333H1.337C.601 17.333.004 16.737.004 16l-.001-2.06H0v-1.333l.003-.001V1.333C.004.641.534.071 1.21.006L1.337 0zM5.332 13.94H1.337V16h3.995v-2.06zm7.332 0H6.665V16h5.999v-2.06zm6.002 0h-4.665V16h4.666l-.001-2.06zm-13.334-4H1.337v2.666h3.995V9.94zm7.332 0H6.665v2.666h5.999V9.94zm6.002 0h-4.665v2.666h4.665V9.94zm0-8.607H1.338v7.273h3.995V3.94h1.333v4.666h5.999V3.94h1.337v4.666h4.665V1.333z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0ydu8tqydc",
    d: "M20 5.333H0v-4C0 .597.597 0 1.333 0h17.334C19.403 0 20 .597 20 1.333v4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    transform: "translate(-309 -239) translate(105 119) translate(160 112) translate(44 8)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-309 -239) translate(105 119) translate(160 112) translate(44 8) translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.667,
    cy: 16.889,
    r: 16,
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.667 8.222)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "czxfsswaab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pp4n459hqa"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#A5A5A5",
    xlinkHref: "#pp4n459hqa"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#czxfsswaab)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H26.667V26.667H0z",
    transform: "translate(-3.333 -4.667)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.667 8.222)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fd6uuvtend",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0ydu8tqydc"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#A5A5A5",
    xlinkHref: "#0ydu8tqydc"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#fd6uuvtend)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H26.667V26.667H0z",
    transform: "translate(-3.333 -4.667)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataGrid);
export default __webpack_public_path__ + "static/media/dataGrid.0591a497a56c4ae3aaecfd297ef610ea.svg";
export { ForwardRef as ReactComponent };